import { LNGS_NAMESPACE_MODULES } from '@ingenico/util-i18n-config';
import { Level, showNotification } from '@ingenico/react-notifications';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface Query {
  readonly isError?: boolean;
  readonly isSuccess?: boolean;
  readonly isLoading?: boolean;
  readonly refetch: () => void;
}

export interface UseRefreshDatagridOutput {
  readonly handleRefresh: () => void;

  readonly isRefetchInProgress: boolean;
}

export function useRefreshDatagrid(query: Query): UseRefreshDatagridOutput {
  const { t } = useTranslation([LNGS_NAMESPACE_MODULES.COMMON]);
  const [isRefetchInProgress, setIsRefetchInProgress] = useState<boolean>(false);

  const handleRefresh = useCallback(() => {
    setIsRefetchInProgress(true);
    query.refetch();
  }, [query]);

  const validateShouldDisplayRefetchError = useCallback(
    (isError: boolean) => {
      if (isError) {
        showNotification({
          level: Level.Error,
          content: t('error.refetchList'),
        });
      } else {
        setIsRefetchInProgress(false);
      }
    },
    [t],
  );

  useEffect(() => {
    if (isRefetchInProgress && (query?.isError || query?.isSuccess) && !query?.isLoading) {
      validateShouldDisplayRefetchError(Boolean(query?.isError));
    }
  }, [isRefetchInProgress, query, validateShouldDisplayRefetchError]);

  return { handleRefresh, isRefetchInProgress };
}
